import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { FileHelper } from 'apps/idl/src/helpers';
import { IGalleryFile } from 'apps/idl/src/model';
import { IDmsData } from 'apps/idl/src/modules/dms/model/IDmsData';
import { DmsService } from 'apps/idl/src/modules/dms/services/dms.service';
import { BlobUrlManager } from 'apps/idl/src/modules/filesystem/BlobUrlManager';
import { GalleryService } from 'apps/idl/src/services/security';
import { Subject, asyncScheduler, of, } from 'rxjs';
import { catchError, observeOn, takeUntil, tap } from 'rxjs/operators';


@Component({
	selector: 'di-carte-photo',
	templateUrl: './carte-photo.component.html',
	styleUrls: ['./carte-photo.component.scss'],
})
export class CartePhotoComponent implements OnInit, AfterViewInit, OnDestroy {

	isLargeScreen: boolean = false;
	isImageLoading: boolean = true;
	private readonly moBlobUrlManager = new BlobUrlManager();

	@Input() photoFile: IGalleryFile | File;
	@Input() edit: boolean = false;
	@Output() delete = new EventEmitter<File | IGalleryFile>();
	isFile: boolean = false;
	fileData: IDmsData;
	fileName: string;

	private destroy$ = new Subject<void>();


	fileUrl: string | ArrayBuffer = '';
	isOverlayOpen: boolean = false;
	isImageAvailable: boolean = true;


	constructor(
		private svcDms: DmsService,
		private readonly sanitizer: DomSanitizer,
		private readonly svcGallery: GalleryService,
		private changeDetector: ChangeDetectorRef,
	) { }



	ngOnInit(): void {
		// this.isImageAvailable = false;
		this.isImageLoading = true;
	}

	ngAfterViewInit(): void {
		this.loadImage();
	}

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}



	private loadImage() {
		if (this.isGalleryFile(this.photoFile)) {
			this.svcDms.get(this.photoFile.guid).pipe(
				observeOn(asyncScheduler),
				tap((doc: IDmsData) => {
					this.fileData = doc;
					this.checkFileType();
					if (this.fileData.file.File) {
						if (this.isFile) {
							this.fileName = decodeURIComponent(escape(this.fileData.file.Name));
						}
						const lsValueToSanitize: string = this.fileData.file.File instanceof Blob ? this.moBlobUrlManager.createUrl(this.fileData.file.File) : this.fileData.file.File;
						this.fileUrl = this.sanitizer.bypassSecurityTrustUrl(lsValueToSanitize) as string;
						this.isImageLoading = false;
						this.isImageAvailable = true;
						this.changeDetector.detectChanges();
					}
				}),
				catchError(error => {
					this.isImageLoading = false
					this.isImageAvailable = false;
					this.changeDetector.detectChanges();
					return of(null);
				}),
				takeUntil(this.destroy$),
			).subscribe();
		} else {
			this.checkFileType();
			this.fileUrl = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(this.photoFile as Blob)) as string;
			this.isImageAvailable = true;
			this.isImageLoading = false;
			this.changeDetector.detectChanges();
		}
	}

	private isGalleryFile(file: any): file is IGalleryFile {
		return file && (file as IGalleryFile).guid !== undefined;
	}


	openOverlay(): void {
		if (!this.isFile && !this.isImageAvailable) return;

		this.isOverlayOpen = true;
	}

	onImageLoad(): void {
		this.isImageLoading = false;
	}

	closeOverlay(): void {
		this.isOverlayOpen = false;
	}

	deletePhoto(): void {
		this.delete.emit(this.photoFile);
	}

	checkFileType(): void {
		const imageTypes = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'heic', 'heif'];
		if (this.photoFile instanceof File || this.photoFile instanceof Blob) {
			const fileExtension = FileHelper.getExtensionFromMimeType(this.photoFile.type);
			this.isFile = !imageTypes.includes(fileExtension);
		}
		else {
			const fileExtension = FileHelper.getExtensionFromMimeType(this.fileData.file.MimeType);
			this.isFile = !imageTypes.includes(fileExtension);
		}
		if (this.isFile) {
			this.fileName = this.photoFile instanceof File || Object ? this.photoFile.name : this.photoFile.file.Name
		}
	}
}
